import { render } from "./ComplexidadePorProgramador.vue?vue&type=template&id=60040f47"
import script from "./ComplexidadePorProgramador.vue?vue&type=script&lang=js"
export * from "./ComplexidadePorProgramador.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/alperlab/alperlab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__